export type AppConfigType = {
  WEB_APP_URL: string;
  SignalR_URL: string;
  SERVER_URL: string;
  BASE_API_URL: string;
  [key: string]: string; // optional: allows future keys
};

class AppConfigClass {
  private config: AppConfigType | null = null;

  load = async () => {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (!res.ok) {
      throw new Error(`Failed to load app config, ${res.status}`);
    }
    this.config = await res.json();
  };

  get WEB_APP_URL() {
    this.ensureLoaded();
    return this.config!.WEB_APP_URL;
  }

  get SignalR_URL() {
    this.ensureLoaded();
    return this.config!.SignalR_URL;
  }

  get SERVER_URL() {
    this.ensureLoaded();
    return this.config!.SERVER_URL;
  }

  get BASE_API_URL() {
    this.ensureLoaded();
    return this.config!.BASE_API_URL;
  }
  get MAX_MEDICAL_FILE_COUNT() {
    this.ensureLoaded();
    return this.config!.MAX_MEDICAL_FILE_COUNT;
  }

  get(key: string) {
    this.ensureLoaded();
    return this.config![key];
  }

  // Internal check
  private ensureLoaded() {
    if (!this.config) {
      throw new Error("AppConfig not loaded yet. Call AppConfig.load() before using it.");
    }
  }
}

// Export a single instance
export const AppConfig = new AppConfigClass();